import { Injectable } from '@angular/core';
import { MepStorage } from './abstract/mep-storage.abstract';

@Injectable({
  providedIn: 'root',
})
export class StorageMobileService implements MepStorage {
  private async _preferences() {
    const { Preferences } = await import('@capacitor/preferences');
    return Preferences;
  }

  public async get(key: string): Promise<string> {
    const preferences = await this._preferences();
    const result = await preferences.get({ key });
    return result.value;
  }

  public async set(key: string, value: string): Promise<void> {
    const preferences = await this._preferences();
    await preferences.set({ key, value });
  }

  public async remove(key: string): Promise<void> {
    const preferences = await this._preferences();
    await preferences.remove({ key });
  }

  public removeItems(keys: any[]): void {
    keys.forEach(async (key) => {
      await this.remove(key);
    });
  }

  setItems(items: { [key: string]: any }): void {
    Object.keys(items).forEach((key) => {
      const value = items[key].toString();
      this.set(key, value);
    });
  }
}
